import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { accountingEnabled } from '../config/features';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const { t } = useTranslation();

  const navItems = [
    {
      to: '/',
      label: t('nav.home'),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3.75 13.5l8.25-8.25 8.25 8.25M5.25 12v7.5h13.5V12" />
        </svg>
      ),
    },
    {
      to: '/portfolio',
      label: t('nav.portfolio'),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
        </svg>
      ),
    },
    {
      to: '/subscriptions',
      label: t('nav.subscriptions'),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
        </svg>
      ),
    },
    {
      to: '/expenses',
      label: 'Расходы',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M5 3h14v18l-3-2-4 2-4-2-3 2V3zM8 8h8M8 12h6" />
        </svg>
      ),
    },
    {
      to: '/accounting',
      label: 'Бухгалтерия',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 4h16v16H4V4zM9 4v16M9 9h11M9 14h11" />
        </svg>
      ),
    },
    {
      to: '/settings',
      label: t('nav.settings'),
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex h-screen overflow-hidden bg-md-surface">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/32 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* MD3 Navigation Drawer */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-40 w-[272px] flex flex-col border-r border-md-outline-variant
          bg-md-surface-container-lowest
          transition-transform duration-300 ease-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        {/* Drawer header / Logo */}
        <div className="flex items-center gap-3 px-6 py-5 mt-2">
          <div className="w-9 h-9 rounded-md-md bg-md-primary flex items-center justify-center">
            <span className="text-md-on-primary font-bold text-sm tracking-[-0.08em]">tFd</span>
          </div>
          <div>
            <h1 className="text-base font-semibold text-md-on-surface tracking-tight">TarifData</h1>
            <p className="text-xs text-md-on-surface-variant">Подписки и расходы</p>
          </div>
        </div>

        {/* Navigation items */}
        <nav className="flex-1 px-3 py-2 space-y-1" aria-label="Основная навигация" id="sidebar-nav">
          {navItems.filter(item => item.to !== '/accounting' || accountingEnabled).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => isActive ? 'md-nav-item-active' : 'md-nav-item'}
              id={`nav-${item.label.toLowerCase()}`}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User profile */}
        <div className="px-3 py-4">
          <div className="flex items-center gap-3 px-3 py-3 rounded-md-lg bg-md-surface-container">
            <div className="w-9 h-9 rounded-md-full bg-md-primary flex items-center justify-center text-sm font-semibold text-md-on-primary">
              {user?.username?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-md-on-surface truncate">{user?.username || 'User'}</p>
              <p className="text-xs text-md-on-surface-variant truncate">{user?.email || ''}</p>
            </div>
            <button
              onClick={() => void logout()}
              className="text-md-on-surface-variant hover:text-md-error transition-colors p-1 rounded-md-full hover:bg-md-error-container/30"
              title="Logout"
              id="logout-button"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* MD3 Top App Bar (mobile only) */}
        <header className="flex items-center gap-4 px-4 py-3 bg-md-surface-container-lowest border-b border-md-outline-variant lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-md-on-surface-variant hover:text-md-on-surface transition-colors p-1 rounded-md-full hover:bg-md-surface-container-high"
            id="mobile-menu-button"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="text-lg font-semibold text-md-on-surface">TarifData</h1>
        </header>

        {/* Content area */}
        <div className="flex-1 overflow-y-auto bg-md-surface">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
